import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import { StudentSessionState } from '../../features/student/store/student-session/student-session.state';

// Endpoints that must NOT receive the Authorization header
const NO_AUTH_PATTERNS: RegExp[] = [/\/assets\//i];

function requestNeedsAuthToken(req: HttpRequest<unknown>): boolean {
  return !NO_AUTH_PATTERNS.some((re) => re.test(req.url));
}

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private store: Store) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // First, decide if the request should have a token AT ALL.
    if (!requestNeedsAuthToken(req)) {
      // If it shouldn't have a token, but has one, it must be removed.
      if (req.headers.has('Authorization')) {
        const cleanReq = req.clone({
          headers: req.headers.delete('Authorization')
        });
        return next.handle(cleanReq);
      }
      // Otherwise, just let it pass through.
      return next.handle(req);
    }

    // If we are here, the request NEEDS a token.
    // If the request already has a header (e.g. from a retry), let it pass.
    if (req.headers.has('Authorization')) {
      return next.handle(req);
    }

    // Get current token from session snapshot
    const accessToken = this.store.selectSnapshot(StudentSessionState.token);

    // If a token is available, add it.
    if (accessToken) {
      const authReq = req.clone({
        setHeaders: { Authorization: `Bearer ${accessToken}` }
      });
      return next.handle(authReq);
    }

    // If we have no token, let it pass. The next interceptors will handle 401s.
    return next.handle(req);
  }
}
